import { createPortal } from 'react-dom'

import { CloseIcon } from '@/assets/icons'
import { Heading } from '@/components/ui/tailwind/Heading'
import { cn } from '@/helpers/cn'

import type { ReactNode } from 'react'

interface ModalProps {
  open: boolean
  title?: ReactNode
  children: ReactNode
  onClose: () => void
  className?: string
}

export const Modal = ({ open, title, children, onClose, className }: ModalProps) => {
  if (!open) {
    return null
  }

  return createPortal(
    <div className="fixed inset-0 z-1200 flex items-center justify-center">
      <div className="absolute inset-0 bg-background-dark-transparent" onClick={onClose} />

      <div
        className={cn(
          'relative z-10 flex max-h-[90vh] w-full max-w-lg flex-col rounded-md bg-background-default p-10 shadow-lg',
          className
        )}
      >
        <div className="flex shrink-0 items-center justify-between">
          <Heading size="h2" className="m-0 mb-4">
            {title}
          </Heading>

          <CloseIcon onClick={onClose} className="m-2.5 size-6 cursor-pointer text-secondary-default" />
        </div>

        <div className="min-h-0 overflow-y-auto">{children}</div>
      </div>
    </div>,
    document.body
  )
}
